import { ItemValue } from "../../../item-value";
import React, { memo, ReactElement } from "react";
import { RenderingDetails } from "@swiggy-private/cart-types";
import styles from "../../../BillDetailItem.scss";

interface ValueProps {
    itemKey: string;
    itemData: RenderingDetails;
    isInTooltip: boolean;
    onItemClick?: VoidFunction;
    totalSavings: number;
}

const Value = ({ itemData, isInTooltip, onItemClick }: ValueProps): ReactElement => {
    const { value, intermediateText, meta, icon } = itemData;
    return (
        <ItemValue
            value={value}
            intermediateText={intermediateText}
            intermediateTextStyle={styles.rupee}
            isNegative={itemData.is_negative == 1}
            meta={meta}
            icon={icon}
            isInTooltip={isInTooltip}
            onItemClick={onItemClick}
            itemKey={itemData.key}
        />
    );
};

export default memo(Value);
